module.exports = __webpack_public_path__ + "static/img/service-active.6fb348c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tabbar/service-active.png
// module id = Nuax
// module chunks = 0